import { DocumentsList } from '@/components/documents/DocumentsList';

export const RegistrationUploadDocuments = () => {
  return (
    <div className="flex flex-col gap-8 max-w-[1000px]">
      <DocumentsList />
    </div>
  );
};
